import http from '@frontend/api/http';
import { HYPATIA_URL } from '@frontend/envConfig';
import { MessageTrigger } from '@frontend/types/workflow-agent';

// Type for partial updates to message triggers
export type MessageTriggerUpdate = Partial<Omit<MessageTrigger, 'id' | 'type'>>;

export const updateMessageTrigger = async (
  url: string,
  updates: MessageTriggerUpdate
): Promise<MessageTrigger> => {
  const response = await http.patch<MessageTrigger>(url, updates);
  return response.data;
};

export const createMessageTrigger = async (
  agentId: string,
  instanceId: string,
  trigger: Record<string, unknown>
): Promise<MessageTrigger> => {
  const url = `${HYPATIA_URL}/api/v1/${instanceId}/agents/workflows/${agentId}/triggers/message`;
  const response = await http.post<MessageTrigger>(url, trigger);
  return response.data;
};

export const getMessageTrigger = async (url: string): Promise<MessageTrigger> => {
  const response = await http.get<MessageTrigger>(url);
  return response.data;
};

export const deleteMessageTrigger = async (url: string): Promise<void> => {
  await http.delete(url);
};
